<template>
  <div class="custom-margin">
    <div class="custom-card contact-card">
      <div class="custom-card-content">
        <div class="columns is-vcentered">
          <div class="column is-2 pr-0 pb-0">
            <b-icon icon="question-circle" size="is-large" class="pink"></b-icon>
          </div>
          <div class="column pt-5 pl-0 pb-0">
            <span class="area-title">{{ $t("projet.en-bref.une-question") }}</span>
          </div>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-2 pr-0 pt-0"></div>
          <div class="column pl-0 pt-0 column-card">
            <div class="columns is-vcentered">
              <div class="column is-one-third">
                <b-button
                  class="is-primary is-outlined is-rounded"
                  tag="a"
                  target="_blank"
                  href="https://ame.ofb.fr/doku.php"
                  >{{ $t("projet.en-bref.wiki") }}
                </b-button>
              </div>
              <div class="column is-one-third">
                <b-button
                  class="is-primary is-outlined is-rounded"
                  tag="a"
                  target="_blank"
                  href="https://ame.ofb.fr/doku.php?id=sagafaq"
                  >{{ $t("projet.en-bref.faq") }}
                </b-button>
              </div>
              <div class="column is-one-third">
                <b-button
                  class="is-primary is-outlined is-rounded is-flex is-align-items-center is-justify-content-center"
                  tag="a"
                  target="_blank"
                  href="https://www.facebook.com/groups/804644174157988/"
                  style="padding-top: 9px"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    class="bi bi-facebook"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"
                    />
                  </svg>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-card mt-2 contact-card" style="height: 210px; margin-bottom: 50px">
      <div class="custom-card-content">
        <div class="columns is-vcentered">
          <div class="column is-2 pr-0 pb-0">
            <b-icon icon="address-card" size="is-large" class="pink"></b-icon>
          </div>
          <div class="column pt-5 pl-0 pb-0">
            <span class="area-title">{{ $t("projet.en-bref.contact") }}</span>
          </div>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-2 pr-0 pt-0"></div>
          <div class="column pl-0 pt-0 column-card">
            <div class="columns">
              <div class="column">
                <p>{{ displayedContact.prenom }} {{ displayedContact.nom }}</p>
                <p v-if="displayedContact.profil">{{ $t(displayedContact.profil) }}</p>
                <p class="mt-3 is-vcentered">
                  <b-icon
                    icon="phone"
                    size="is-medium"
                    style="padding-right: 5px"
                    class="pink"
                  ></b-icon>
                  {{ displayedContact.telephone }}
                </p>
                <p class="is-vcentered">
                  <b-icon
                    icon="envelope-open-text"
                    size="is-medium"
                    style="padding-right: 5px"
                    class="pink"
                  ></b-icon>
                  <a target="_blank" :href="'mailto:' + displayedContact.courriel">
                    {{ displayedContact.courriel }}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { defineComponent, PropType } from "vue"
import { BButton, BIcon } from "buefy"

export default defineComponent({
  name: "ContactCardsView",
  components: {
    BIcon,
    BButton,
  },
  props: {
    contact: {
      type: Object as PropType<UtilisateurDTO>,
      required: true,
    },
  },
  data() {
    return {
      displayedContact: new UtilisateurDTO(),
    }
  },
  watch: {
    contact: {
      handler(newValue: UtilisateurDTO): void {
        this.setContact(newValue)
      },
      immediate: true,
    },
  },
  created(): void {
    this.setContact(this.contact)
  },
  methods: {
    setContact(newValue: UtilisateurDTO): void {
      if (!newValue.id) {
        this.setDefaultContact()
      } else {
        this.displayedContact = newValue
      }
    },

    setDefaultContact(): void {
      this.displayedContact.courriel = this.$t("default.email")
      this.displayedContact.telephone = this.$t("default.phone")
      this.displayedContact.nom = this.$t("default.profil")
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

$pp-actu-padding-hor: 1rem;
$pp-actu-padding-vert: 0.3rem;

$card-width: 450px;
$card-height: 120px;
.custom-card {
  width: $card-width;
  height: $card-height;
  border-radius: 10px;
  border: 1px solid $bookmarkcard-border-color;
}

.contact-card {
  width: auto;
  margin: 5px;
}

.custom-margin {
  margin-top: 23.2px;
}
</style>
